<div class="menu-wrapper text-secondary position-fixed vh-100 left-0 shadow overflow-hidden" [class.locked]="lock">
  <nav class="sidebar" [ngClass]="{ lock: lock }">
    <div class="menu-container p-1">
      <ul class="list-unstyled">
        <li class="item lock-container d-md-flex justify-content-end d-md-block d-none">
          <div
            class="lock-item p-2 rounded-circle shadow-sm d-flex align-items-center justify-content-center cursor"
            [class]="lock ? 'text-primary' : 'text-secondary'"
            (click)="lockToggle()"
          >
            <i class="bi" [ngClass]="{ 'bi-lock-fill': lock, 'bi-unlock-fill': !lock }"></i>
          </div>
        </li>
        @for(navigationItem of navigation;track $index) {
        <app-sub-sidebar
          [depthVal]="0"
          (expandSublevel)="selectSubitem($event)"
          [item]="navigationItem"
          [index]="$index"
        >
        </app-sub-sidebar>
        }
      </ul>
    </div>
  </nav>
</div>
<div class="menu-overlay w-100 h-100 position-fixed start-0"></div>
